import { geSections } from './data';

export const getGeSectionByName = (name: string) => {
  const geSection = geSections[name];
  return geSection;
};
